/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Not_A_TrainerInputs */

const en_us2_group_not_a_trainer = /** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the group's trainers see its students.`)
};

const pt_br2_group_not_a_trainer = /** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quem treina a turma vê os alunos.`)
};

const pt_pt2_group_not_a_trainer = /** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quem treina a turma vê os alunos.`)
};

/** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */
const es_419_group_not_a_trainer = en_us2_group_not_a_trainer;

/** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */
const fr_fr2_group_not_a_trainer = en_us2_group_not_a_trainer;

/** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */
const de_de2_group_not_a_trainer = en_us2_group_not_a_trainer;

/** @type {(inputs: Group_Not_A_TrainerInputs) => LocalizedString} */
const it_it2_group_not_a_trainer = en_us2_group_not_a_trainer;

/**
* | output |
* | --- |
* | "Only the group's trainers see its students." |
*
* @param {Group_Not_A_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_not_a_trainer = /** @type {((inputs?: Group_Not_A_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Not_A_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_not_a_trainer(inputs)
	if (locale === "es-419") return es_419_group_not_a_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_group_not_a_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_group_not_a_trainer(inputs)
	if (locale === "de-DE") return de_de2_group_not_a_trainer(inputs)
	if (locale === "it-IT") return it_it2_group_not_a_trainer(inputs)
	return en_us2_group_not_a_trainer(inputs)
});
export { group_not_a_trainer as "group.not_a_trainer" }